//import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort';
import { TableModule } from 'primeng/table';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CdkTableModule } from '@angular/cdk/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';

import { AppComponent } from './app.component';
import { DentalReferralFormComponent } from './dental-referral-form/dental-referral-form.component';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AlertService } from './common/alert.service';
import { LoadingService } from './common/loading.service';
import { SpinnerComponent } from './common/spinner/spinner.component';
import { PhoneNumberPipe } from './common/pipe/phone-number.pipe';
import { NavigationLayoutComponent } from './common/navigation-layout/navigation-layout.component';
import { DcoAdminComponent } from './admin/dco-admin/dco-admin.component';
import { DcoAddEditDialogComponent } from './admin/dco-admin/dco-add-edit-dialog/dco-add-edit-dialog.component';
import { UserAdminComponent } from './admin/user-admin/user-admin.component';
import { ResolutionCenterComponent } from './resolution-center/resolution-center.component';
import { DcoReferralsComponent } from './dco-referrals/dco-referrals.component';
import { ListAdminComponent } from './admin/list-admin/list-admin.component';
import { ListItemEditDialogComponent } from './admin/list-admin/list-item-edit-dialog/list-item-edit-dialog.component';
import { DcoReferralDetailsDialogComponent } from './dco-referrals/dco-referral-details-dialog/dco-referral-details-dialog.component';
import { NotesContainerComponent } from './common/notes-container/notes-container.component';
import { CommonNoteComponent } from './common/notes-container/common-note/common-note.component';
import { ReprocessRequestDialogComponent } from './common/reprocess-request-dialog/reprocess-request-dialog.component';
import { MemberEnrollmentDetailsComponent } from './common/member-enrollment-details/member-enrollment-details.component';
import { ReferralHistoryComponent } from './common/referral-history/referral-history.component';
import { SafeHtmlPipe } from './common/pipe/safe-html.pipe';
import { MemberSearchDialogComponent } from './common/member-search-dialog/member-search-dialog.component';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LoginComponent } from './auth/login/login.component';
import { TokenBootstrapService } from './auth/services/token-bootstrap.service';
import { authInterceptor } from './auth/interceptors/auth.interceptor';
import { LogoutConfirmDialogComponent } from './auth/logout/logout-confirm-dialog/logout-confirm-dialog.component';
import { UserManagementTableComponent } from './admin/user-admin/user-management-table/user-management-table.component';
import { UserEditDialogComponent } from './admin/user-admin/user-edit-dialog/user-edit-dialog.component';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe } from '@angular/common';
import { ConfirmDialogComponent } from './common/confirm-dialog/confirm-dialog.component';
import { ActiveUsersTableComponent } from './admin/user-admin/active-users-table/active-users-table.component';
import { ExportDialogComponent } from './common/export/export-dialog/export-dialog.component';
import { ExportModule } from './common/export/export.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { AppSettingsComponent } from './admin/app-settings/app-settings.component';
import { MemberReferralHistoryComponent } from './common/member-referral-history/member-referral-history.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ReferralStatusDialogComponent } from './common/referral-status-dialog/referral-status-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    DentalReferralFormComponent,
    SpinnerComponent,
    PhoneNumberPipe,
    NavigationLayoutComponent,
    DcoAdminComponent,
    DcoAddEditDialogComponent,
    UserAdminComponent,
    ResolutionCenterComponent,
    DcoReferralsComponent,
    ListAdminComponent,
    ListItemEditDialogComponent,
    DcoReferralDetailsDialogComponent,
    NotesContainerComponent,
    CommonNoteComponent,
    ReprocessRequestDialogComponent,
    MemberEnrollmentDetailsComponent,
    ReferralHistoryComponent,
    SafeHtmlPipe,
    MemberSearchDialogComponent,
    LoginComponent,
    LogoutConfirmDialogComponent,
    UserManagementTableComponent,
    UserEditDialogComponent,
    AccessDeniedComponent,
    ConfirmDialogComponent,
    ActiveUsersTableComponent,
    AppSettingsComponent,
    MemberReferralHistoryComponent,
    ReferralStatusDialogComponent
    //CommonModule
  ],
  imports: [
    BrowserModule,
    //HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSelectModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    MatProgressSpinnerModule,
    MatTableModule,
    MatIconModule,
    MatChipsModule,
    FormsModule,
    MatSortModule,
    TableModule,
    DragDropModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatCardModule,
    MatDividerModule,
    MatTabsModule,
    MatTreeModule,
    MatPaginatorModule,
    CdkTableModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatTooltip,
    MatProgressBarModule,
    MatMenuModule,
    MatTooltipModule,
    ExportModule,
    MatExpansionModule,
    MatButtonToggleModule
  ],
  exports: [
    PhoneNumberPipe,
    LogoutConfirmDialogComponent
  ],
  providers: [
    ToastrService,
    AlertService,
    LoadingService,
    DatePipe,
    provideAnimationsAsync(),
    provideNgxMask({
      validation: false,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: bootstrapToken,
      deps: [TokenBootstrapService],
      multi: true
    },
    provideHttpClient(withInterceptors([authInterceptor]))
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

export function bootstrapToken(tokenService: TokenBootstrapService) {
  return () => tokenService.initializeTokenBootstrap();
}
